/* Copyright 2013 - 2022 Waiterio LLC */
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import AuthenticatedPage from './pages/AuthenticatedPage.js'
import UploadPage from './pages/UploadPage.js'
import LoginPage from './pages/LoginPage.js'
import LogoutPage from './pages/LogoutPage.js'


export default () => (
  <Switch>
    <Redirect exact from="/" to="/login" />

    <Route exact path="/login" component={LoginPage} />
    <Route exact path="/logout" component={LogoutPage} />

    <AuthenticatedPage>
      <Route exact path="/upload" component={UploadPage} />
    </AuthenticatedPage>
  </Switch>
)
